/**
 * @generated SignedSource<<3b1aa9b180fa6a423a0d602daf2dd990>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aggregation"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "finish"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "start"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeZone"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uuid"
},
v5 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "uuid"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalIdentifier",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finish",
  "storageKey": null
},
v10 = [
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeRange",
  "kind": "LinkedField",
  "name": "active",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifier",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tradePointId",
  "storageKey": null
},
v16 = [
  (v14/*: any*/)
],
v17 = {
  "kind": "Variable",
  "name": "finish",
  "variableName": "finish"
},
v18 = {
  "kind": "Variable",
  "name": "start",
  "variableName": "start"
},
v19 = [
  (v17/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 999999999
  },
  (v18/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tradeType",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "givenName",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "familyName",
  "storageKey": null
},
v25 = [
  (v6/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v27 = [
  (v21/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": (v25/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "TradePoint",
    "kind": "LinkedField",
    "name": "tradePoint",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      (v26/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Meter",
        "kind": "LinkedField",
        "name": "meter",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v14/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Property",
            "kind": "LinkedField",
            "name": "property",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ignorePublicHolidays",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monthsOfYear",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "daysOfWeek",
  "storageKey": null
},
v33 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hours",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minutes",
    "storageKey": null
  }
],
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeSpan",
  "kind": "LinkedField",
  "name": "timesOfDay",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeOfDayType",
      "kind": "LinkedField",
      "name": "start",
      "plural": false,
      "selections": (v33/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeOfDayType",
      "kind": "LinkedField",
      "name": "finish",
      "plural": false,
      "selections": (v33/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "proposedAt",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "acceptedAt",
  "storageKey": null
},
v37 = {
  "kind": "Variable",
  "name": "aggregation",
  "variableName": "aggregation"
},
v38 = {
  "kind": "Variable",
  "name": "timeZone",
  "variableName": "timeZone"
},
v39 = [
  (v37/*: any*/),
  (v17/*: any*/),
  {
    "kind": "Literal",
    "name": "metric",
    "value": "elec_energy_consumed"
  },
  (v18/*: any*/),
  (v38/*: any*/)
],
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aggregation",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeZone",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeRange",
  "kind": "LinkedField",
  "name": "timeRange",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "Valid",
  "storageKey": null
},
v47 = [
  (v40/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Metric",
    "kind": "LinkedField",
    "name": "metric",
    "plural": false,
    "selections": (v16/*: any*/),
    "storageKey": null
  },
  (v41/*: any*/),
  (v42/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CalculatedDatum",
    "kind": "LinkedField",
    "name": "data",
    "plural": true,
    "selections": [
      (v43/*: any*/),
      (v44/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Flag",
        "kind": "LinkedField",
        "name": "flags",
        "plural": true,
        "selections": [
          (v14/*: any*/),
          (v45/*: any*/),
          (v46/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v48 = [
  (v37/*: any*/),
  (v17/*: any*/),
  {
    "kind": "Literal",
    "name": "metric",
    "value": "elec_energy_generated"
  },
  (v18/*: any*/),
  (v38/*: any*/)
],
v49 = {
  "alias": null,
  "args": [
    (v37/*: any*/),
    (v17/*: any*/),
    {
      "kind": "Literal",
      "name": "groups",
      "value": [
        "SUMMARY_GROUP_TRADE_POINT",
        "SUMMARY_GROUP_TRADE_RULE",
        "SUMMARY_GROUP_DIRECTION",
        "SUMMARY_GROUP_TRADE_TYPE"
      ]
    },
    (v18/*: any*/),
    (v38/*: any*/)
  ],
  "concreteType": "TradeSetSummary",
  "kind": "LinkedField",
  "name": "tradeSetSummary",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeSetSummaryKey",
      "kind": "LinkedField",
      "name": "key",
      "plural": false,
      "selections": [
        (v15/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ruleId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "direction",
          "storageKey": null
        },
        (v26/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeSetSummaryValue",
      "kind": "LinkedField",
      "name": "data",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeRange",
          "kind": "LinkedField",
          "name": "range",
          "plural": false,
          "selections": (v10/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "buyerTradePointIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sellerTradePointIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "directions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "types",
          "storageKey": null
        },
        (v44/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "volume",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "averagePrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tradeCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "intervalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v51 = [
  (v14/*: any*/),
  (v50/*: any*/)
],
v52 = [
  (v6/*: any*/),
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v50/*: any*/)
],
v53 = [
  (v21/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": (v52/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "TradePoint",
    "kind": "LinkedField",
    "name": "tradePoint",
    "plural": false,
    "selections": [
      (v6/*: any*/),
      (v26/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Meter",
        "kind": "LinkedField",
        "name": "meter",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v14/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Property",
            "kind": "LinkedField",
            "name": "property",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v12/*: any*/),
              (v50/*: any*/)
            ],
            "storageKey": null
          },
          (v50/*: any*/)
        ],
        "storageKey": null
      },
      (v50/*: any*/)
    ],
    "storageKey": null
  }
],
v54 = [
  (v40/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Metric",
    "kind": "LinkedField",
    "name": "metric",
    "plural": false,
    "selections": (v51/*: any*/),
    "storageKey": null
  },
  (v41/*: any*/),
  (v42/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CalculatedDatum",
    "kind": "LinkedField",
    "name": "data",
    "plural": true,
    "selections": [
      (v43/*: any*/),
      (v44/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Flag",
        "kind": "LinkedField",
        "name": "flags",
        "plural": true,
        "selections": [
          (v14/*: any*/),
          (v45/*: any*/),
          (v46/*: any*/),
          (v50/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioShowChunkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Portfolio",
        "kind": "LinkedField",
        "name": "portfolio",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "MeterConnection",
            "kind": "LinkedField",
            "name": "meters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeterEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Meter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v14/*: any*/),
                      (v7/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PrimaryBillingPoint",
                        "kind": "LinkedField",
                        "name": "primaryBillingPoint",
                        "plural": false,
                        "selections": (v16/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Property",
                        "kind": "LinkedField",
                        "name": "property",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v19/*: any*/),
                        "concreteType": "TradeRuleConnection",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeRuleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TradeRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Trader",
                                    "kind": "LinkedField",
                                    "name": "buyer",
                                    "plural": false,
                                    "selections": (v27/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Trader",
                                    "kind": "LinkedField",
                                    "name": "seller",
                                    "plural": false,
                                    "selections": (v27/*: any*/),
                                    "storageKey": null
                                  },
                                  (v28/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ClauseConnection",
                                    "kind": "LinkedField",
                                    "name": "clauses",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ClauseEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Clause",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v29/*: any*/),
                                              (v30/*: any*/),
                                              (v31/*: any*/),
                                              (v32/*: any*/),
                                              (v34/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v35/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "proposedBy",
                                    "plural": false,
                                    "selections": (v25/*: any*/),
                                    "storageKey": null
                                  },
                                  (v36/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "acceptedBy",
                                    "plural": false,
                                    "selections": (v25/*: any*/),
                                    "storageKey": null
                                  },
                                  (v8/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "dataConsumed",
                        "args": (v39/*: any*/),
                        "concreteType": "CalculatedData",
                        "kind": "LinkedField",
                        "name": "calculatedData",
                        "plural": false,
                        "selections": (v47/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "dataGenerated",
                        "args": (v48/*: any*/),
                        "concreteType": "CalculatedData",
                        "kind": "LinkedField",
                        "name": "calculatedData",
                        "plural": false,
                        "selections": (v47/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "meters(first:500)"
          },
          (v49/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PortfolioShowChunkQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*: any*/),
        "concreteType": "Portfolio",
        "kind": "LinkedField",
        "name": "portfolio",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "MeterConnection",
            "kind": "LinkedField",
            "name": "meters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeterEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Meter",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v14/*: any*/),
                      (v7/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PrimaryBillingPoint",
                        "kind": "LinkedField",
                        "name": "primaryBillingPoint",
                        "plural": false,
                        "selections": (v51/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Property",
                        "kind": "LinkedField",
                        "name": "property",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v19/*: any*/),
                        "concreteType": "TradeRuleConnection",
                        "kind": "LinkedField",
                        "name": "rules",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeRuleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TradeRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Trader",
                                    "kind": "LinkedField",
                                    "name": "buyer",
                                    "plural": false,
                                    "selections": (v53/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Trader",
                                    "kind": "LinkedField",
                                    "name": "seller",
                                    "plural": false,
                                    "selections": (v53/*: any*/),
                                    "storageKey": null
                                  },
                                  (v28/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ClauseConnection",
                                    "kind": "LinkedField",
                                    "name": "clauses",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ClauseEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Clause",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v29/*: any*/),
                                              (v30/*: any*/),
                                              (v31/*: any*/),
                                              (v32/*: any*/),
                                              (v34/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v35/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "proposedBy",
                                    "plural": false,
                                    "selections": (v52/*: any*/),
                                    "storageKey": null
                                  },
                                  (v36/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "acceptedBy",
                                    "plural": false,
                                    "selections": (v52/*: any*/),
                                    "storageKey": null
                                  },
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "dataConsumed",
                        "args": (v39/*: any*/),
                        "concreteType": "CalculatedData",
                        "kind": "LinkedField",
                        "name": "calculatedData",
                        "plural": false,
                        "selections": (v54/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "dataGenerated",
                        "args": (v48/*: any*/),
                        "concreteType": "CalculatedData",
                        "kind": "LinkedField",
                        "name": "calculatedData",
                        "plural": false,
                        "selections": (v54/*: any*/),
                        "storageKey": null
                      },
                      (v50/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "meters(first:500)"
          },
          (v49/*: any*/),
          (v50/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6749fc580c9af3c03db914e72787ef06",
    "id": null,
    "metadata": {},
    "name": "PortfolioShowChunkQuery",
    "operationKind": "query",
    "text": "query PortfolioShowChunkQuery(\n  $uuid: ID!\n  $start: Timestamp!\n  $finish: Timestamp!\n  $timeZone: String!\n  $aggregation: String!\n) {\n  portfolio(uuid: $uuid) {\n    uuid\n    externalIdentifier\n    active {\n      start\n      finish\n    }\n    title\n    meters(first: 500) {\n      edges {\n        node {\n          uuid\n          identifier\n          externalIdentifier\n          active {\n            start\n            finish\n          }\n          title\n          tradePointId\n          primaryBillingPoint {\n            identifier\n            id\n          }\n          property {\n            uuid\n            id\n          }\n          rules(first: 999999999, start: $start, finish: $finish) {\n            edges {\n              node {\n                uuid\n                tradeType\n                buyer {\n                  userId\n                  user {\n                    uuid\n                    email\n                    givenName\n                    familyName\n                    id\n                  }\n                  tradePoint {\n                    uuid\n                    type\n                    meter {\n                      uuid\n                      identifier\n                      title\n                      property {\n                        uuid\n                        title\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                }\n                seller {\n                  userId\n                  user {\n                    uuid\n                    email\n                    givenName\n                    familyName\n                    id\n                  }\n                  tradePoint {\n                    uuid\n                    type\n                    meter {\n                      uuid\n                      identifier\n                      title\n                      property {\n                        uuid\n                        title\n                        id\n                      }\n                      id\n                    }\n                    id\n                  }\n                }\n                state\n                clauses {\n                  edges {\n                    node {\n                      price\n                      ignorePublicHolidays\n                      monthsOfYear\n                      daysOfWeek\n                      timesOfDay {\n                        start {\n                          hours\n                          minutes\n                        }\n                        finish {\n                          hours\n                          minutes\n                        }\n                      }\n                      id\n                    }\n                  }\n                }\n                proposedAt\n                proposedBy {\n                  uuid\n                  email\n                  givenName\n                  familyName\n                  id\n                }\n                acceptedAt\n                acceptedBy {\n                  uuid\n                  email\n                  givenName\n                  familyName\n                  id\n                }\n                start\n                finish\n                id\n              }\n            }\n          }\n          dataConsumed: calculatedData(start: $start, finish: $finish, aggregation: $aggregation, timeZone: $timeZone, metric: \"elec_energy_consumed\") {\n            aggregation\n            metric {\n              identifier\n              id\n            }\n            timeZone\n            timeRange {\n              start\n              finish\n            }\n            data {\n              timestamp\n              value\n              flags {\n                identifier\n                description\n                Valid\n                id\n              }\n            }\n          }\n          dataGenerated: calculatedData(start: $start, finish: $finish, aggregation: $aggregation, timeZone: $timeZone, metric: \"elec_energy_generated\") {\n            aggregation\n            metric {\n              identifier\n              id\n            }\n            timeZone\n            timeRange {\n              start\n              finish\n            }\n            data {\n              timestamp\n              value\n              flags {\n                identifier\n                description\n                Valid\n                id\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n    tradeSetSummary(start: $start, finish: $finish, timeZone: $timeZone, aggregation: $aggregation, groups: [SUMMARY_GROUP_TRADE_POINT, SUMMARY_GROUP_TRADE_RULE, SUMMARY_GROUP_DIRECTION, SUMMARY_GROUP_TRADE_TYPE]) {\n      key {\n        tradePointId\n        ruleId\n        direction\n        type\n      }\n      data {\n        range {\n          start\n          finish\n        }\n        buyerTradePointIds\n        sellerTradePointIds\n        directions\n        types\n        value\n        volume\n        averagePrice\n        tradeCount\n        intervalCount\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "9352b387dc769bde8ed22f0526697dee";

module.exports = node;
